export const USER_NOTIFICATIONS_COPY = {
	DAYS_AGO: (days: number): string => `${days} days ago`,
	DAY_AGO: 'A day ago',
	EMPTY: 'No Notifications',
	HOURS_AGO: (hours: number): string => `${hours} hours ago`,
	HOUR_AGO: 'An hour ago',
	LESS_MINUTE_AGO: 'Less than a minute ago',
	MINUTES_AGO: (minutes: number): string => `${minutes} minutes ago`,
	MINUTE_AGO: 'A minute ago',
	WEEK_AGO: 'A week ago'
};
